import { API_BASE_URL } from "constants/ApiConstant";
import {
  cookieGETAdminID,
  cookieGETBranchID,
  cookieGETToken,
  cookieGETUserID,
} from "cookie/general";

/**
 * Headers for every back-office call.
 *
 * Carries the signed token: /app routes now reject requests without one. The
 * till shares this helper and simply has no token to send, which is correct --
 * its routes are exempt, and attaching nothing is what they expect.
 */
export function apiHeaders() {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const token = cookieGETToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return headers;
}

/**
 * As above. x-admin-id is still sent, but nothing trusts it any more --
 * productWriteAccess now reads the id out of the verified token. It is left in
 * place only because request logging records it; treat it as a log field, not
 * as a credential, and do not add a new consumer of it.
 */
export function adminApiHeaders() {
  const headers = apiHeaders();

  const adminID = cookieGETAdminID();
  if (adminID) {
    headers["x-admin-id"] = adminID;
  }

  return headers;
}

export function logHeaders() {
  const empId = cookieGETUserID();
  const branchId = cookieGETBranchID();

  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Accept", "application/json");

  if (empId) {
    headers.append("x-employee-id", empId);
  }
  if (branchId) {
    headers.append("x-branch-id", branchId);
  }

  headers.append("x-timestamp", new Date().toISOString());

  // Back-office routes reject requests without this. logHeaders is used by the
  // calls that also record who did what (refunds, stock movements), and those
  // are exactly the ones that must not be callable without a credential.
  const token = cookieGETToken();
  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }

  return headers;
}

export async function APIcreate(key, data) {
  return await fetch((process.env.REACT_APP_API_URL || API_BASE_URL) + key, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify(data),
    headers: apiHeaders(),
  }).then((response) => response.json());
}

export function APIgetall(key) {
  return fetch((process.env.REACT_APP_API_URL || API_BASE_URL) + key, { headers: apiHeaders() }).then(
    (response) => response.json(),
  );
}

export function APIgetid(key, id) {
  return fetch((process.env.REACT_APP_API_URL || API_BASE_URL) + key + id, { headers: apiHeaders() }).then(
    (response) => response.json(),
  );
}

export function APIdelete(key, id) {
  return fetch((process.env.REACT_APP_API_URL || API_BASE_URL) + key + id, {
    method: "DELETE",
    mode: "cors",
    headers: apiHeaders(),
  }).then((response) => response.json());
}

export function APIupdate(key, data, id) {
  return fetch((process.env.REACT_APP_API_URL || API_BASE_URL) + key + id, {
    method: "PATCH",
    mode: "cors",
    body: JSON.stringify(data),
    headers: apiHeaders(),
  }).then((response) => response.json());
}
